import React from 'react';

import { ApolloError } from '@apollo/client';
import { EmptyIllustration } from '@dashboard/components/empty-states/EmptyIllustration';
import { alertError } from '@dashboard/contexts/SnackbarManager/store';
import { useCreateTemplateFromExistingMutation, useLayoutTemplatesListQuery } from '@dashboard/generated/wp/platform';
import { useShowTemplateNavigate } from '@dashboard/hooks/navigate/usePlatformNavigator';
import { Box } from '@mui/material';

import SampleTemplateCard from '../SampleTemplateCard';

type Props = {
  close: () => void;
};
export default function LayoutsList({ close }: Props) {
  const { data } = useLayoutTemplatesListQuery();
  const [createTemplateFromLayout, { loading: loadingMutation }] = useCreateTemplateFromExistingMutation();

  const showTemplate = useShowTemplateNavigate();

  const onCreateFromLayout = async (id: string | null) => {
    if (!id) {
      return;
    }
    try {
      const { data } = await createTemplateFromLayout({ variables: { id } });
      close();
      if (!data?.createTemplateFromExisting) {
        throw new Error('Template creation failed');
      }
      showTemplate(data.createTemplateFromExisting.id);
    } catch (e) {
      if (e instanceof ApolloError) {
        alertError(e.message);
      } else {
        alertError('Error creating template');
      }
    }
  };

  if (data === undefined) {
    return null;
  }

  const nodes = data?.WaypointTemplates.nodes ?? [];
  if (nodes.length === 0) {
    return <EmptyIllustration caption="No template layouts available" />;
  }
  return (
    <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
      {nodes.map((n, i) => (
        <SampleTemplateCard
          key={i}
          title={n.name}
          template={n}
          onClick={onCreateFromLayout}
          disabled={loadingMutation}
        />
      ))}
    </Box>
  );
}
